import React, { useEffect, useRef, useState } from "react";
import IComponentTabs from "react-common-components/dist/components/Tab/interface";
import Tabs from "src/components/Tabs";
import { useTranslation } from "src/context/Translations/context";
import { IDiagnosticTabs, IMdtbb002001, IRefDiagnosticTab } from "../../interface";
import TabDiagnostic from "./components/tabCriteria";
import TabSummary from "./components/tabSummary";

const DiagnosticTabs: React.FC<IDiagnosticTabs> = ({
	selectedDiagnostic,
	mdtba002s,
	callbackOnClick
}) => {

	const { translate } = useTranslation();

	const itemsRef = useRef<IRefDiagnosticTab[]>([]);

	const [tabsDiagnostic, setTabsDiagnostic] = useState<IComponentTabs["options"]>([]);

	const createTabs = () => {
		if(!mdtba002s)
			setTabsDiagnostic([]);

		let tabs: IComponentTabs["options"] = [];
		mdtba002s.forEach((mdtba002: IMdtbb002001, index) => {
			tabs = [
				...tabs,
				{
					label: mdtba002.mda002Titulo,
					content: <TabDiagnostic selectedDiagnostic={selectedDiagnostic.mdb001Id} mdtba002={mdtba002} ref={(el) => {
						if(el)
							itemsRef.current[index] = el;
					}} />,
					onClick: () => { itemsRef.current[index].openTab(); }
				}
			];
		});	

		setTabsDiagnostic(tabs);
	};

	useEffect(() => {
		itemsRef.current = itemsRef.current.slice(0, tabsDiagnostic.length);
	}, [tabsDiagnostic]);

	useEffect(() => {
		createTabs();
	}, [mdtba002s]);

	return (
		<>
			{/* As tabs de criterios são componentes individuais que possuem uma ref, 
				ao clicar em uma delas, chama o metodo de request que se localiza dentro do componente */}
			<Tabs 
				name="tabsDiagnostic" 
				styleInline="max-width: 100%; padding-right: 1rem;"
				tabInit={0} 
				options={[
					{
						label: translate("Resumo"),
						content: <TabSummary data={mdtba002s} selectedDiagnostic={selectedDiagnostic} />,
						onClick: () => { callbackOnClick(); }
					},
					...tabsDiagnostic
				]}					
			/>
		</>
	);
};	

export default DiagnosticTabs;
